"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var url_1 = require("url");
var generateTraceId_1 = require("./generateTraceId");
var addI18nNamespaceToErrorMessage_1 = require("./addI18nNamespaceToErrorMessage");
function axiosClientFactory(config, getTokens, getTraceId, removeTokens) {
    var instance = axios_1.default.create({
        baseURL: url_1.format(config.url),
        transformResponse: __spreadArrays(axios_1.default.defaults.transformResponse, [
            config.i18nNamespace ? addI18nNamespaceToErrorMessage_1.addI18nNamespaceToErrorMessage(config.i18nNamespace) : function (data) { return data; }
        ])
    });
    if (getTokens) {
        instance.interceptors.request.use(function (cfg) {
            return getTokens().then(function (token) {
                cfg.headers.common.Authorization = "Bearer " + token.accessToken;
                return cfg;
            });
        });
        if (removeTokens) {
            instance.interceptors.response.use(function (cfg) { return cfg; }, function (error) {
                if (error.response.status === 401) {
                    removeTokens();
                }
                return Promise.reject(error);
            });
        }
    }
    instance.interceptors.request.use(function (cfg) {
        if (getTraceId != null) {
            cfg.headers.common['X-B3-TraceId'] = getTraceId();
        }
        else {
            cfg.headers.common['X-B3-TraceId'] = generateTraceId_1.generateTraceId();
        }
        cfg.headers.common['X-B3-SpanId'] = generateTraceId_1.generateTraceId();
        return cfg;
    });
    instance.send = function (url, data, metadata) {
        var config;
        if (metadata) {
            config = {
                headers: {
                    common: {
                        'X-UT-GRPC-METADATA': JSON.stringify(metadata)
                    }
                }
            };
        }
        return instance.post(url, data, config);
    };
    return instance;
}
exports.axiosClientFactory = axiosClientFactory;
//# sourceMappingURL=axiosClientFactory.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@utex/base-api-sdk/dist/utils/axiosClientFactory.js
// module id = 773
// module chunks = 118